// Time conversion factors
export const MILLIS_PER_SEC = 1000;
export const MILLIS_PER_MIN = 60000;
export const MILLIS_PER_HR = 3600000;

export const ROUTES = {
    UPDATE_GRAPHS_METADATA: "/needed-graphs-metadata",
    GET_SINGLE_VALUES: "/single-values",
    GET_GRAPH_DATA: "components/graph",
    GET_PROCESSED_DATA: "components/get-processed-data",
}
